// @flow
import I18n from '../../../../lib/i18n';
import { formatValue } from '../../../../lib/usage-formatters';

const formatSmsLegend = (currentValue: number, maxValue: number) => ({
  current: currentValue === 0 ? I18n.t('nothing') : formatValue(currentValue, 'SMS'),
  max: formatValue(maxValue, 'SMS'),
});

export default formatSmsLegend;
